import { Input_Base } from '@services/MarppleShopStudio/widget/CreatorProduct/ui/ProductForm/input-views/Input_Base.ts';
import {
  AllStockInputKeys,
  Base_InputStock,
  StockInputValue,
} from '@services/MarppleShopStudio/widget/CreatorProduct/ui/ProductForm/input-views/Input_Stock/types.ts';
import { PureInputType } from '../../../../../../../../shared/rune-component/Input/PureInput.ts';
import {
  ChangeSpoItemValue,
  DeleteSpoItems,
} from '@services/MarppleShopStudio/widget/CreatorProduct/ui/ProductForm/input-views/Input_Stock/events.ts';
import { ValidateField } from '@services/MarppleShopStudio/widget/CreatorProduct/core/zod-schema/shared.ts';
import { Html, View } from 'rune-ts';
import { NumberTextInputType } from '../../../../../../../../shared/rune-component/Input/NumberTextInput.ts';
import { ButtonCheckbox } from '@services/MarppleShop/renderApp/components/atoms/ButtonCheckbox/ButtonCheckbox.ts';
import klass from '@services/MarppleShopStudio/widget/CreatorProduct/ui/ProductForm/input-views/Input_Stock/Input_Stock.module.scss';
import { StudioButton } from '@services/MarppleShop/shared/components/atoms/StudioButton/StudioButton.ts';

export const ALL_CHECK_NAME = 'ALL_CHECK_NAME';
export const CHECK_BOX_KLASS = 'CHECK_BOX_KLASS';

export abstract class Base_Input_Stock<T extends Base_InputStock> extends Input_Base<T> {
  override onRender() {
    this.delegate('change', ButtonCheckbox, (_, v) => {
      const allCheckbox = this.subViews(ButtonCheckbox).find((view) => view.getName() === ALL_CHECK_NAME);
      const childCheckboxes = this.subViews(ButtonCheckbox).filter(
        (view) => view.getName() !== ALL_CHECK_NAME,
      );

      if (v.getName() === ALL_CHECK_NAME) {
        this.applyAllCheck(v.isChecked());
      } else {
        // 자식 체크박스 상태 변화 시 부모 체크박스 상태 업데이트
        const checkedCount = childCheckboxes.filter((view) => view.isChecked()).length;

        // 모든 자식이 체크되어야만 부모 체크, 하나라도 해제되면 부모도 해제
        if (checkedCount === childCheckboxes.length) {
          // 모든 자식이 체크되면 부모도 체크
          allCheckbox?.activate();
        } else {
          // 하나라도 체크 안되어 있으면 부모 해제
          allCheckbox?.deactivate();
        }
      }

      const is_some_check = childCheckboxes.some((view) => view.isChecked());

      if (is_some_check) {
        this.element().querySelector(`.${klass.button_wrap}`)?.classList.remove(klass.hidden);
      } else {
        this.element().querySelector(`.${klass.button_wrap}`)?.classList.add(klass.hidden);
      }
    });

    this.delegate('click', StudioButton, () => {
      const delete_target_indexes = this.subViews(ButtonCheckbox)
        .filter((view) => view.getName() !== ALL_CHECK_NAME)
        .map((view, index) => ({ view, index }))
        .filter(({ view }) => view.isChecked())
        .map(({ index }) => index);

      this.dispatchEvent(DeleteSpoItems, {
        bubbles: true,
        detail: {
          delete_target_indexes,
        },
      });
    });
  }

  private applyAllCheck(is_check: boolean) {
    this.subViews(ButtonCheckbox).forEach((view) => {
      is_check ? view.activate() : view.deactivate();
    });
  }

  protected onStringOptionChange(view: PureInputType, key: AllStockInputKeys) {
    this.setValueWithIndex(key, view.getIndex(), view.getValue());

    this.dispatchEvent(ChangeSpoItemValue, {
      bubbles: true,
      detail: {
        stock_values: this.getValue(),
      },
    });
  }

  protected onNumericOptionChange(view: NumberTextInputType, key: AllStockInputKeys) {
    this.setValueWithIndex(key, view.getIndex(), view.getNumericValue() ?? 0);

    this.dispatchEvent(ChangeSpoItemValue, {
      bubbles: true,
      detail: {
        stock_values: this.getValue(),
      },
    });
  }

  protected setValueWithIndex(key: AllStockInputKeys, index: number, input_value: number | string) {
    this.data.value = this.data.value.map((item, idx) =>
      idx === index ? { ...item, [key]: input_value } : item,
    );

    return this;
  }

  getName(): ValidateField {
    return this.data.name;
  }

  getValue(): StockInputValue[] {
    return this.data.value;
  }

  setError(): void {
    return void 0;
  }

  protected abstract override inputTemplate(): Html | View;
}
